<div class="privacy-url-container d-flex flex-wrap align-items-center">
  <div class="logo-image"></div>
  <div class="ml-1">
    <a href="/privacy/gdpr" class="mr-1 fg-color6"           aria-label="Privacy"
    >Privacy</a>
    <a href="/privacy/terms&conditions" class="fg-color6"           aria-label="Terms and Conditions"
    >Terms & Conditions</a>
  </div>
</div>
